<template>
    <div style="height: 98%;">
        <div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-office-building"></i><span>系统设置</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>实体管理</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
        <!-- <el-divider></el-divider> -->
        
        <div class="container" style="padding: 15px;height: 92%;">
            <div style="padding-bottom: 10px;">
                <el-row type="flex"> 
                    <el-col :span="8">
                        <!-- <el-button type="primary" style="width: 80px" @click="invCompanyDetailClickFun('0', '')">新增</el-button>
                        <el-button plain style="width: 80px" @click="deleteInvCompanyData()">删除</el-button>
                        <el-button plain style="width: 80px">导出</el-button> -->
                    </el-col>
                    <el-col :span="16" style="text-align: right;">
                        <el-input v-model="companySearchName" placeholder="搜索实体名称、实体税号、联系人、手机号" prefix-icon="el-icon-search" style="width: 350px" @keyup.native="advanceQueryCompanyData()"/>
                    </el-col>
                </el-row>
            </div>
            <div style="height: 94%;">
                <el-table :data="invCompanyData" border stripe height="90%" class="table" @row-dblclick="viewInvCompanyDetail" ref="invCompanyTable" @row-click="clickRowByChecked" highlight-current-row>
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="id" v-if="showColumn"></el-table-column>
                    <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contact" label="联系人" sortable></el-table-column>
                    <el-table-column prop="phoneNumber" label="手机" sortable></el-table-column>
                    <el-table-column prop="state" label="当前状态" width="80" :formatter="this.formatStatus"></el-table-column>
                    <el-table-column prop="companyGroup.state" label="集团状态" width="80" :formatter="this.formatStatus"></el-table-column>
                    <el-table-column prop="operate" label="操作" width="100" align="center" fixed="right">
                        <template slot-scope="scoped">
                            <el-button size="small" type="text" @click="invCompanyDetailClickFun('2', scoped.row)">查看</el-button>
                            <el-button size="small" type="text" @click="invCompanyDetailClickFun('1', scoped.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pwm.page"
                        :page-size="pwm.limit"
                        :page-sizes="pwm.limits"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pwm.count">
                    </el-pagination>
                </div>
            </div>
        </div>
        
        <!-- 查看、编辑、新增 -->
        <el-dialog :title="invCompanyTitle" :visible.sync="invCompanyDialogVisible" width="55%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="invCompanyForm" ref="invCompanyForm" :rules="invCompanyFormRule">
                    <el-input v-if="hideId == true" v-model="invCompanyForm.id" id="hideId"></el-input>
                    <el-input v-if="hideId == true" v-model="invCompanyForm.groupId"></el-input>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title">基本信息</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 实体名称</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="name">
                                        <el-input v-model="invCompanyForm.name" :disabled="spDisabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 是否启用</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="state">
                                        <el-select v-model="invCompanyForm.state" placeholder="请选择" style="width: 100%;" :disabled="spDisabled">
                                            <el-option
                                                v-for="item in this.statusData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 实体编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="code">
                                        <el-input v-model="invCompanyForm.code" :disabled="spDisabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 实体税号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="taxNumber">
                                        <el-input v-model="invCompanyForm.taxNumber" :disabled="spDisabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 授权密钥</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="authKey">
                                        <el-input v-model="invCompanyForm.authKey" :disabled="spDisabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>所属集团</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupName">
                                        <el-input v-model="invCompanyForm.companyGroup.name" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupNo">
                                        <el-input v-model="invCompanyForm.companyGroup.code" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title">详细信息</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>银行、账号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="bankAccount">
                                        <el-input v-model="invCompanyForm.bankAccount" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>地址、电话</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="addressPhone">
                                        <el-input v-model="invCompanyForm.addressPhone" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title">联系人</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 姓名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="contact">
                                        <el-input v-model="invCompanyForm.contact" id="contactName" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 手机</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="phoneNumber">
                                        <el-input v-model="invCompanyForm.phoneNumber" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>邮箱</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="email">
                                        <el-input v-model="invCompanyForm.email" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>备注</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="position">
                                        <el-input v-model="invCompanyForm.position" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" style="width: 80px;" v-if="isShowBtn" @click="saveInvCompanyClickFun('invCompanyForm')">保存</el-button>
                <el-button @click="invCompanyDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import https, { fetchGet, fetchPost, serializeJson } from '../../../../https.js';
    export default {
        data() {
            return {
                pwm: {
                    count: 0,
                    limit: 10,
                    page: 1,
                    limits: [10, 20, 50, 100]
                },
                showColumn: false,  //  id列是否隐藏
                hideId: false,
                isShowBtn: true,    //  新增、编辑、查看 dialog 保存按钮是否显示
                companySearchName: '',
                invCompanyData: [],
                invCompanyDialogVisible: false,
                invCompanyTitle: '',
                invCompanyOpUrl: '',
                invCompanyForm: {
                    sellerName: '',
                    status: '0',
                    sellerTaxNumber: '',
                    authCode: '',
                    groupName: '',
                    groupNo: '',
                    bankAccount: '',
                    addressPhone: '',
                    contactName: '',
                    contactPhone: '',
                    email: '',
                    remark: '',
                    companyGroup: {}
                },
                invCompanyFormRule: {
                    name: [
                        { required: true, message: '请输入实体名称', trigger: 'blur'},
                        { max: 20, message: '实体名称不得超过20个字符'}
                    ],
                     code: [
                        { required: true, message: '请输入实体编号', trigger: 'blur'},
                        { max: 10, message: '实体编号不得超过10个字符'}
                    ],
                    taxNumber: [
                        { required: true, message: '请输入实体税号', trigger: 'blur'},
                        { min: 15, max: 18, message: '实体税号不得超过15~18个字符'}
                    ],
                    authKey: [
                        { required: true, message: '请输入授权密钥', trigger: 'blur'}
                    ],
                    bankAccount: [
                        { required: false, max: 50, message: '银行、账号不得超过50个字符'}
                    ],
                    addressPhone: [
                        { required: false, max: 50, message: '地址、电话不得超过50个字符'}
                    ],
                    contact: [
                        { required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        { max: 10, message: '联系人姓名不得超过10个字符'}
                    ],
                    phoneNumber: [
                        { required: true, message: '请输入联系人手机号', trigger: 'blur'},
                        { validator: this.checkMobile }
                    ],
                    email: [
                        { max: 40, message: '联系人邮箱长度不得超过40个字符' },
                        { validator: this.checkEmail }
                    ]
                },
                disabled: false,    //  字段是否禁用
                spDisabled: false,
                currGroupData: '',  //  当前集团信息
            }
        },
        created: function() {
            this.getCurrentGroupData().then(res => {    //  curr group data
                this.getInvCompanyTableData(); //  load table data
            });
        },
        mounted: function() {
        },
        methods: {
            handleSizeChange(val) {
                this.pwm.limit = val;
                this.getInvCompanyTableData();
            },
            handleCurrentChange(val) {
                this.pwm.page = val;
                this.getInvCompanyTableData();
            },
            async getCurrentGroupData() { //  当前集团信息
                await fetchPost('/sys/admin/getCurrentCompanyGroup', '').then(res => {
                    if(res.data.success) {
                        this.currGroupData = res.data.obj;
                    } else {
                        this.$message.error('获取当前集团信息错误：' + error);
                        return;
                    }
                }, error => {
                    this.$message.error('获取当前集团信息错误：' + error);
                });
            },
            clickRowByChecked(row) {    //  点击即选中该行
                this.$refs.invCompanyTable.toggleRowSelection(row);
            },
            getInvCompanyTableData: function() { //  load table data
                this.pwm.search = { "groupId": this.currGroupData.id };
                fetchPost('/sys/main/getCurrentCompanyList', this.pwm).then(result => {
                    this.invCompanyData = result.data.data;
                    this.pwm.count = result.data.count;
                }).catch (error => {
                    this.$message.error('加载开票公司数据错误：' + error);
                });
            },
            getCompanyById(rowData) {   //  查看详情
                fetchPost('/sys/admin/getCompanyById', rowData.id).then(res => {
                    if(res.data.success) {
                        this.invCompanyForm = res.data.obj;
                        this.invCompanyDialogVisible = true;
                    } else {
                        this.$message.error('加载实体信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载实体信息失败：' + error);
                });
            }, 
            advanceQueryCompanyData() { //  实体管理 模糊查询
                this.pwm.page = 1;
                this.pwm.limit = 10;
                let pwm = this.pwm;
                pwm.likeSearch = this.companySearchName;
                this.getInvCompanyTableData();
            },
            viewInvCompanyDetail(row, column, event) {
                this.invCompanyDetailClickFun('2', row);
            },
            invCompanyDetailClickFun(opType, rowData) {    //  新增、编辑、查看 dialog
                Object.keys(this.invCompanyForm).map(key => (this.invCompanyForm[key] = ''));
                this.$nextTick(() => {
                    if(this.$refs.invCompanyForm) {
                        this.$refs.invCompanyForm.clearValidate();   //  重置表单校验
                    }
                });
                if(opType == '0') {
                    this.invCompanyTitle = '实体信息新增';
                    this.isShowBtn = true;
                    this.disabled = false;
                    this.spDisabled = false;
                    this.invCompanyForm.state = '0';
                    this.invCompanyForm.companyGroup = {
                        name: this.currGroupData.name,
                        code: this.currGroupData.code
                    };
                    this.invCompanyOpUrl = '/sys/admin/addCompany';
                    this.invCompanyDialogVisible = true;
                } else if(opType == '1') {
                    this.invCompanyTitle = '实体信息编辑';
                    this.isShowBtn = true;
                    this.disabled = false;
                    this.spDisabled = true;

                    this.getCompanyById(JSON.parse(JSON.stringify(rowData)));
                    this.invCompanyOpUrl = '/sys/admin/updateCompany';
                } else if(opType == '2') {
                    this.invCompanyTitle = '实体信息查看';
                    this.isShowBtn = false;
                    this.disabled = true;
                    this.spDisabled = true;

                    // this.invCompanyForm = JSON.parse(JSON.stringify(rowData));
                    this.getCompanyById(JSON.parse(JSON.stringify(rowData)));
                }
            },
            saveInvCompanyClickFun(formName) {  //  保存新增、编辑数据
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let companyData = this.invCompanyForm;;
                    companyData.groupId = this.currGroupData.id;
                    fetchPost(this.invCompanyOpUrl, companyData).then(res => {
                        if(res.data.success) {
                            this.$message.success('保存实体信息成功！');
                            this.invCompanyDialogVisible = false;   //  关闭dialog
                            //  reload company table
                            this.getInvCompanyTableData();
                        } else {
                            this.$message.error('保存实体信息失败：' + res.data.message);   
                        }
                    }, error => {
                        this.$message.error('保存实体信息失败：' + error);
                    });
                });
            },
            deleteInvCompanyData() {    //  删除
                let idList = [];
                let rows = this.$refs.invCompanyTable.selection;
                if(!rows || rows.length == 0) {
                    this.$message.warning('请选择需要删除的实体信息？');
                    return;
                }
                rows.forEach(row => {
                    idList.push(row.id);
                });
                this.$confirm('是否删除当前选中实体信息？', '提示', { type: 'warning'}).then(res => {
                    let ids = idList.join(',');
                    fetchPost('/sys/admin/deleteCompanys', ids).then(res => {
                        if(res.data.success) {
                            this.$message.success('删除实体公司信息成功！');
                            this.companyOperateDialogVisible = false;
                            //  reload company table
                            this.getInvCompanyTableData();
                        } else {
                            this.$message.error('删除实体公司信息失败：' + res.data.message);
                        }
                    }, error => {
                        this.$message.error('删除实体公司信息失败：' + error);
                    });
                });
            },
        }
    }
</script>

<style scoped>
    .table {
        width: 100%;
        font-size: 14px;
    }
</style>